import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';

interface FilePreview {
  url: string;
  type: string;
  name: string;
  size: number;
  file: File;
}

@Component({
  selector: 'common-file-upload',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
})
export class FileUploadComponent {
  @ViewChild('fileInput') fileInput?: ElementRef<HTMLInputElement>;
  @Input() maxFileSize = 10 * 1024 * 1024; // Default 10MB
  @Input() acceptedFileTypes = '.jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.txt,.xlsx,.xls';
  @Input() buttonText = 'Upload Files';
  @Output() filesSelected = new EventEmitter<File[]>();

  errors: string[] = [];

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    this.errors = [];
    const newFiles = Array.from(input.files);
    this.filesSelected.emit(newFiles);
    if (this.fileInput) this.fileInput!.nativeElement.value = '';
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
